import { Component, OnInit, signal } from "@angular/core";
import { ConfirmationService, MenuItem } from "primeng/api";
import { Subscription } from "rxjs";
import { DataService } from "../../data.service";
import { Track4ShipmentModel, ShipmentDetailsModel, CargoFeaturesModel } from "../../model";
import { DateUtils } from "../../shared/date-utils";
import { confirmMessage } from "../../shared/message-utils";
import { AuthService } from "../../auth/auth.service";


@Component({
    selector: 'app-admin-shipments',
    templateUrl: './admin-shipments.component.html',
    styleUrls: ['./admin-shipments.component.css'],
    standalone: false
})
export class AdminShipmentsComponent implements OnInit {
    fd: any;
    td: any;

    storages: any;
    storeId!: number;
    shipmentsData: any;
    chageShipmentDate: boolean = true;
    showTrackSelectDialog: boolean = false;
    showCitySelectDialog: boolean = false;
    tracks4Shipment?: Track4ShipmentModel[];
    selectedTracks: number[] = [];
    dataLoadingState = signal<boolean>(false);
    cargoFeatures?: CargoFeaturesModel;

    shipmentStoragies: any;
    selectedCity: number | null = null;

    sendBtnClickFn : any;
    shipmentItems!: MenuItem[];

    constructor(private dataService: DataService, private authService: AuthService, private confirmationService: ConfirmationService) {
        this.authService.cargoFeatures().then((cargoFeatures: CargoFeaturesModel) => {
            this.cargoFeatures = cargoFeatures;
            this.sendBtnClickFn = this.cargoFeatures?.isDestStorage ? this.selectCityDialog : this.makeShipment;
        });

        this.shipmentItems  = [
            {
                label: 'Выбрать треки',
                icon: 'pi pi-check pi-fw',
                command: (event) => this.showTrackSelect()
            },
        ];
    }

    loadData() {
        this.td = new Date();

        this.dataService.storages().subscribe((data) => {
            this.storages = data;
            if (data && Array.isArray(data) && data.length > 0) {
                this.storeId = data[0].id;
                this.fd = new Date(data[0].last_shipment);

                this.shipmentsData = this.dataService.shipmentsData(this.storeId);
            }
        });

       
    }

    ngOnInit() {
        this.loadData();
    }

    selectCityDialog() {
        this.showCitySelectDialog = true;
        const fd = DateUtils.unixTimestamp(this.fd);
        const td = DateUtils.unixTimestamp(this.td);
        const subscr = this.dataService.storagiesForShipment(fd, td, this.storeId).subscribe({
            next: (data) => {
                this.shipmentStoragies = data.map((a: any) => (
                    {
                        id: parseInt(a.id),
                        name: a.name + (a.cnt > 0 ? ` (${a.cnt})` : '')
                    }
                ))

                this.shipmentStoragies = [{ id: null, name: "Все города" }, ...this.shipmentStoragies]
            },
            complete: () => {
                subscr.unsubscribe();
            },
            error: (err) => {
                subscr.unsubscribe();
            }
        });
    }

    setFirstDate(event: any) {
        const store = this.storages.find((value: any, index: number, obj: any) => {
            return value.id === this.storeId // todo: check!!!
        });

        //_.find(this.storages, { id: this.store });
        if (store) {
            this.fd = new Date(store.lastShipment);
        }
    }

    shipmentData(shipment: any) {
        function toCSV(d: ShipmentDetailsModel) {
            let cdate = d.dt != null ? DateUtils.formatDate(new Date(d.dt!)) : null;
            return `${d.id};"${d.tracknum}";"${cdate}";"${d.title}";${d.weight};"${d.login}";"${d.client_code}";${d.deleted}\n`
        }

        function downloadAsFile(data: string) {
            const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
            const blob = new Blob([BOM, data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = `shipment_${shipment.id}.csv`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        }

        const subscr: Subscription = this.dataService.getShipmentDetails(shipment.id).subscribe({
            next: (data: ShipmentDetailsModel[]) => {
                let blobData = '"Track Id";"Track number";"Create Date";"Title";"Weight";"Login";"Client Code";"Is deleted"\n';
                data.forEach((element: ShipmentDetailsModel) => {
                    blobData += toCSV(element);
                });

                downloadAsFile(blobData);
            },
            complete: () => {
                subscr.unsubscribe();
            }

        });
    }

    showTrackSelect() {
        this.dataLoadingState.set(true);
        this.showTrackSelectDialog = true;
        const subscr = this.dataService.packagesForShipment(
            DateUtils.unixTimestamp(this.fd),
            DateUtils.unixTimestamp(this.td),
            this.storeId
        ).subscribe({
            next: (data: Track4ShipmentModel[]) => {
                this.tracks4Shipment = data;
            },
            complete: () => {
                subscr.unsubscribe();
                this.dataLoadingState.set(false);
            }
        })
    }

    cancelTrackSelect() {
        this.tracks4Shipment = [];
        this.showTrackSelectDialog = false;
        this.selectedTracks = [];
    }

    makeShipment() {
        confirmMessage(
            this.confirmationService,
            'Вы уверены, что хотите отправить посылки?',
            () => {
                const subscr = this.dataService.makeShipment(
                    DateUtils.unixTimestamp(this.fd),
                    DateUtils.unixTimestamp(this.td),
                    this.storeId,
                    this.selectedCity
                ).subscribe({
                    next: (data) => {
                        if (data === 'ok') {
                            this.loadData();
                        }
                    },
                    complete: () => {
                        subscr.unsubscribe();
                        this.selectedCity = null;
                    },
                    error: (err) => {
                        subscr.unsubscribe();
                        this.selectedCity = null;
                    }
                });
            }
        );
    }

    shipSelectedTracks() {
        const subscr = this.dataService.shipSelectedPackages(
            DateUtils.unixTimestamp(this.fd),
            DateUtils.unixTimestamp(this.td),
            this.storeId,
            this.selectedTracks
        ).subscribe({
            next: (data) => {
                console.log(data);
                this.cancelTrackSelect();
            },
            complete: () => {
                subscr.unsubscribe();
            }
        })

        console.log(this.selectedTracks);
    }

    makeShipmentByCity() {
        this.showCitySelectDialog = false;
        this.makeShipment();
    }

    storageSelected() {
        const selectedStore = this.storages.find((storage: any) => storage.id == this.storeId);
        this.fd = new Date(selectedStore.last_shipment);
        this.shipmentsData = this.dataService.shipmentsData(this.storeId);
    }

}
